import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import { ModuleDataHandler } from '../helpers/handleReportCalc';

interface IProps {
  moduleData: any;
  isView: boolean;
  item: any;
  numberOfDay: any;

  setRender: React.Dispatch<React.SetStateAction<boolean>>;
  index: number;
}

const paymentType: any = {
  co_roll: 'Co. Roll',
  regular: 'Regular',
};

const category_type: any = {
  staff: 'Staff',
  contractual: 'Contractual',
  operator: 'Operator',
};

const TBodyRow = ({
  moduleData,
  isView,
  item,
  index,
  numberOfDay,
  setRender,
}: IProps) => {
  const dataHandler = new ModuleDataHandler(moduleData, numberOfDay);
  return (
    <>
      <tr>
        <td>
          <TableInput
            isView={isView}
            type="text"
            value={item.item_name || null}
            onChange={(e) => {
              item.item_name = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </td>
        <td>
          <TableInput
            isView={isView}
            type="text"
            value={item.operation || null}
            onChange={(e) => {
              item.operation = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </td>
        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.qty || null}
            onChange={(e) => {
              item.qty = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('qty', 'total_qty');
              dataHandler.calculateTotal('amount', 'total_amount');
              setRender((prev) => !prev);
            }}
          />
        </td>
        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.rate || null}
            onChange={(e) => {
              item.rate = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('rate', 'total_rate');
              dataHandler.calculateTotal('amount', 'total_amount');
              setRender((prev) => !prev);
            }}
          />
        </td>
        <td>
          <TableInput isView={true} type="number" value={item.amount || null} />
        </td>
        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.net_wt || null}
            onChange={(e) => {
              item.net_wt = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('net_wt', 'total_net_wt');
              dataHandler.calculateTotal('total_wt', 'total_total_wt');
              dataHandler.calculateTotal('amt', 'total_amt');
              setRender((prev) => !prev);
            }}
          />
        </td>
        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.total_wt || null}
          />
        </td>
        <td>
          <TableInput isView={true} type="number" value={item.amt || null} />
        </td>
        <td>
          <TableInput
            isView={isView}
            type="text"
            value={item.remarks || null}
            onChange={(e) => {
              item.remarks = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </td>
      </tr>
    </>
  );
};

export default TBodyRow;
